import type { ButtonHTMLAttributes, ReactNode } from 'react';

export type ButtonVariant = 'primary' | 'secondary' | 'glow';

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  'data-testid'?: string;
  children: ReactNode;
}

const VARIANT_CLASS: Record<ButtonVariant, string> = {
  primary: 'ds-button-primary',
  secondary: 'ds-button-secondary',
  glow: 'ds-button-glow',
};

/**
 * Token-based button matching agent builder CTA styles.
 */
export function Button({
  variant = 'primary',
  className = '',
  children,
  'data-testid': dataTestId,
  type = 'button',
  ...rest
}: ButtonProps) {
  return (
    <button
      type={type}
      data-testid={dataTestId ?? 'design-system-button'}
      className={`${VARIANT_CLASS[variant]} ${className}`.trim()}
      {...rest}
    >
      {children}
    </button>
  );
}
